import PropTypes from "prop-types";
import { MEDIA_PERMISSIONS } from "../../constants/CallSettingConstants";

const RemoteParticipantsVideoState = ({ isUserVideoEnabled, videoPermission, localisedValues }) => {
    return (
        <div className='participant-action-info custom-tooltip tooltip-auto-width m-hide'>
            <div className='participant-action-icon'>
                {isUserVideoEnabled && <span className='for-icon icon-video active' data-testid='icon-video-active'></span>}
                {!isUserVideoEnabled && videoPermission !== MEDIA_PERMISSIONS.BLOCKED_VALUE && (
                    <span className='for-icon light-icon icon-video-off-stroke' data-testid='icon-video-off'></span>
                )}
                {!isUserVideoEnabled && videoPermission === MEDIA_PERMISSIONS.BLOCKED_VALUE && (
                    <span className='for-blocked-icon' data-testid='icon-video-blocked'>
                        <span className='for-icon light-icon icon-video'></span>
                        <span className='for-close-icon'>
                            <span className='for-close-icon-in icon-close-light'></span>
                        </span>
                    </span>
                )}
            </div>
            <div className='custom-tooltip-content text-nowrap'>
                <div className='custom-tooltip-in'>
                    {isUserVideoEnabled && <p>{localisedValues?.camera_on}</p>}
                    {!isUserVideoEnabled && videoPermission !== MEDIA_PERMISSIONS.BLOCKED_VALUE && <p>{localisedValues?.camera_off}</p>}
                    {!isUserVideoEnabled && videoPermission === MEDIA_PERMISSIONS.BLOCKED_VALUE && <p>{localisedValues?.camera_blocked}</p>}
                </div>
            </div>
        </div>
    );
};
RemoteParticipantsVideoState.propTypes = {
    isUserVideoEnabled: PropTypes.any,
    videoPermission: PropTypes.any,
    localisedValues: PropTypes.any,
};
export default RemoteParticipantsVideoState;
